import { TCustomAxiosError } from '@/services/api';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { postChangeOrganizationLogo } from '@/services/api/requests/organization';

const useChangeOrgLogo = (
  onSuccessCallback?: () => void,
): {
  isError: boolean;
  isPending: boolean;
  mutate: UseMutateFunction<string, TCustomAxiosError, { newLogo: File; organizationId: string }, unknown>;
} => {
  const toast = useToast();

  const { isPending, mutate, isError } = useMutation({
    mutationFn: async ({ newLogo, organizationId }: { newLogo: File; organizationId: string }) => {
      const newUrl = await postChangeOrganizationLogo(organizationId, newLogo);
      return newUrl;
    },
    onSuccess: () => {
      toast({
        status: 'success',
        title: 'Success',
        description: 'Logo updated successfully.',
      });

      onSuccessCallback?.();
    },
    onError: (error: TCustomAxiosError) => {
      toast({
        title: 'Logo updated  photo error',
        description: error.errors[0].message,
        status: 'error',
        isClosable: true,
        duration: 5000,
      });
    },
  });

  return { mutate, isPending, isError };
};

export default useChangeOrgLogo;
